/**
 * Formats a billed job-event window in the company's timezone when available.
 */
export function formatBillingVisitWindow(start: string, end: string, timeZone?: string | null): string {
  const tz = timeZone?.trim() ? timeZone : "UTC";
  try {
    const d0 = new Date(start);
    const d1 = new Date(end);
    const dateFmt = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: tz,
    });
    const timeFmt = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      timeZone: tz,
    });
    const d0s = dateFmt.format(d0);
    const d1s = dateFmt.format(d1);
    if (d0s === d1s) {
      return `${d0s} · ${timeFmt.format(d0)} – ${timeFmt.format(d1)}`;
    }
    return `${d0s} ${timeFmt.format(d0)} – ${d1s} ${timeFmt.format(d1)}`;
  } catch {
    return "—";
  }
}

export function humanizeJobType(type?: string | null): string {
  if (!type) return "—";
  return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
